import { requestAsync } from 'redux-query';
import { STORE_KEYS } from '../constants';
import { createApiFetch } from '../actions/helpers';
import auth from 'dash-front/auth';

export const fetchPortfolio = type => {
    const requestConfig = createApiFetch({
        url: `/api/portfolio/${type || 'default'}?access_token=${auth.getAccessToken()}`,
        key: STORE_KEYS.PORTFOLIO
    });

    return requestAsync(requestConfig);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/portolio.js
 **/